"use client";

import { Modal, ModalProps } from "@mantine/core";
import { useReaderLocked } from "@/app/_providers/StripeTerminalProvider";

// A Modal that will not close while a card payment on this device is under
// way: from Process until the charged payment is saved. Closing mid payment
// would strand the reader on the card screen, or leave a charged card with
// nothing recorded on the job and nobody told. Every payment screen uses this
// so the rule lives in one place.
//
// Hosts can still pass their own close props (false wins); the lock is
// added on top.
const PaymentModal = ({
  onClose,
  closeOnClickOutside = true,
  closeOnEscape = true,
  withCloseButton = true,
  ...props
}: ModalProps) => {
  const locked = useReaderLocked();

  return (
    <Modal
      {...props}
      onClose={() => {
        if (!locked) onClose();
      }}
      closeOnClickOutside={closeOnClickOutside && !locked}
      closeOnEscape={closeOnEscape && !locked}
      withCloseButton={withCloseButton && !locked}
    />
  );
};

export default PaymentModal;
